import { render } from "./DealerWorkingHours.vue?vue&type=template&id=5130ea67"
import script from "./DealerWorkingHours.vue?vue&type=script&lang=js"
export * from "./DealerWorkingHours.vue?vue&type=script&lang=js"

import "./DealerWorkingHours.vue?vue&type=style&index=0&id=5130ea67&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__